<template>
    <div id="app" class="height-p100 fg-main" :class="{ 'is-md-and-down': screenWidth <= 1024 }">
        <router-view v-if="isReloadAlive" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    provide() {
        return {
            reload: this.reload
        }
    },
    name: `App`,
    data() {
        return {
            isReloadAlive: true
        }
    },
    created: function() {
        let theme = localStorage.getItem(`app_theme`)
        if (!theme) {
            const mode = `${this.$root.DefaultThemeColorMode || `1`}`
            if (mode === `2`) {
                theme = `theme-light`
            } else if (mode === `3`) {
                theme = `theme-his-blue`
            } else {
                theme = `theme-dark`
            }
            localStorage.setItem(`app_theme`, theme)
        }
        // theme-his-blue 需要保留 theme-dark 作为 Element UI 基础样式的作用域
        let bodyClass = theme
        if (theme === `theme-his-blue`) {
            bodyClass = `theme-dark theme-his-blue`
        }
        document.getElementById(`app`).parentElement.className = bodyClass
    },
    mounted() {
        let _this = this
        window.onresize = function() { // 定义窗口大小变更通知事件
            let fromDesptop = false
            let clientHeight = document.documentElement.clientHeight
            if (typeof winformMsg != `undefined`) {
                fromDesptop = true
            }
            if (fromDesptop && (_this.$route.query.workerbar && _this.$route.query.workerbar == `false`)) {
                clientHeight = clientHeight + 120
            }
            _this.$store.commit(`setScreenHeight`, clientHeight)
            _this.$store.commit(`setScreenWidth`, document.documentElement.clientWidth)
        }
        if (this.isMobile()) {
            this.$nextTick(() => {
                _this.autofontSize()
            })
            if (window.history && window.history.pushState) {
                window.addEventListener(`popstate`, this.goBack, false)
            }
        }
        document.body.addEventListener(`touchstart`, function() { })
    },
    computed: {
        ...mapGetters([`screenWidth`])
    },
    methods: {
        reload() {
            this.isReloadAlive = false
            this.$nextTick(() => (this.isReloadAlive = true))
        },
        isMobile() {
            // 判断是否是手机端，如果是，返回true
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Tablet|Symbian|Windows Phone)/i)
            let _isMobile = flag != null
            localStorage.setItem(`isMobile`, _isMobile)
            return _isMobile
        },
        goBack() {
            history.pushState(null, null, document.URL)
            if (this.$route.path == `/m_login`) {
                this.$router.replace(`/m_baseinfo`).catch(err => err)
            }
            return false
        },
        // 封装 rem + js 移动端适配方案
        autofontSize() {
            // 把计算下来的当前屏幕html字体值 赋值给html元素 documentElement属性会获取到html根元素 然后为之设置字体值
            // document.documentElement.style.fontSize = `37px`
        }
    },
    // 3、页面销毁时，取消监听
    destroyed() {
        window.removeEventListener(`popstate`, this.goBack, false)
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue